import { render, staticRenderFns } from "./website-foot.vue?vue&type=template&id=9efad242&scoped=true"
import script from "./website-foot.vue?vue&type=script&lang=js"
export * from "./website-foot.vue?vue&type=script&lang=js"
import style0 from "./website-foot.vue?vue&type=style&index=0&id=9efad242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efad242",
  null
  
)

export default component.exports